export const consts = {
  WebClientCookieName: 'WebClient_Id',
  ClientIdCookieParameter: 'ClientGUID',
}

//  DON'T DELETE - used by DW
